import React, { useState } from "react";
import { StyledSignContainer, StyledSignTab } from "./Sign.styles";
import { useNavigate } from "react-router-dom";

import * as accountAPI from "../../apis/accounts";

import { useGoogleLogin } from "@react-oauth/google";
import Terms from "../common/Terms";

import { useTranslation } from "react-i18next";

export default function Sign({ type }) {
  const { t } = useTranslation();

  const routes = [
    ["FN", t("purumnet")],
    ["HR", t("herald")],
    ["SN", t("internet-search")],
    ["OO", "Outside of Korea"],
  ];
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      const { access_token } = tokenResponse;

      accountAPI.loginWithGoogle({ accessToken: access_token }).then((res) => {
        if (res?.data?.linusCode === 1) {
          localStorage.setItem(
            "accessToken",
            res?.data?.data?.tokens?.accessToken
          );
          localStorage.setItem("id", res?.data?.data?.user?.id);
          if (
            !res?.data?.data?.user?.username &&
            !res?.data?.data?.user?.phoneNumber
          ) {
            navigate("/my/info");

            return;
          }

          if (!res?.data?.data?.user?.username) {
            navigate("/my/info");

            return;
          }

          if (!res?.data?.data?.user?.phoneNumber) {
            navigate("/my/info");

            return;
          }

          navigate("/");
        } else if (res?.data?.linusCode === -2) {
          alert("회원정보가 존재하지 않습니다.");
        } else {
          alert(res?.data?.data?.msg);
        }
      });
    },
  });

  return (
    <StyledSignContainer>
      {modalVisible && (
        <div
          className="modal"
          onClick={(e) => {
            e.preventDefault();
            if (
              e.target.className === "contents-container" ||
              e.target.className === "contents" ||
              e.target.className === "title" ||
              e.target.className === "title-text" ||
              e.target.className === "close-container"
            ) {
              return;
            }

            setModalVisible(false);
            document.body.style.overflow = "unset";
          }}
        >
          <div className="modal-contents-container">
            <div className="title">
              <p className="title-text">{t("privacy-policy")}</p>
              <div className="close-container">
                <img src="/img/close-black.svg" alt="close" />
              </div>
            </div>
            <div className="contents">
              <Terms />
            </div>
          </div>
        </div>
      )}
      <div className="upper-container">
        <StyledSignTab
          selected={type === "signUp"}
          className="sign-tab"
          onClick={() => {
            navigate("/auth/sign-up");
          }}
        >
          SIGN UP
        </StyledSignTab>
        <StyledSignTab
          selected={type === "signIn"}
          className="sign-tab"
          onClick={() => {
            navigate("/auth/sign-in");
          }}
        >
          SIGN IN
        </StyledSignTab>
      </div>
      <div className="contents">
        {type === "signIn" && (
          <>
            <h3>Sign In to your account.</h3>
            <p className="desc">
              Build skills for today, tomorrow, and beyond.
              <br />
              Education to future-proof your career.
              <br />
              <br />
              {t("Sign_WhyUseGoogleId")}
            </p>
            <div className="sns-title">
              <div className="decorator" />
              <div className="text">{t("login-sns")}</div>
              <div className="decorator" />
            </div>
            <button
              className="google"
              onClick={(e) => {
                e.preventDefault();
                loginWithGoogle();
              }}
            >
              <img src="/img/icon-sign-google.svg" alt="google" />
              <div>{t("google-login")}</div>
            </button>
          </>
        )}
        {type === "signUp" && (
          <>
            <h3>Create your account.</h3>
            <p className="desc">
              Build skills for today, tomorrow, and beyond.
              <br />
              Education to future-proof your career.
              <br />
              <br />
              {t("Sign_WhyUseGoogleId")}
            </p>
            <div className="sns-title">
              <div className="decorator" />
              <div className="text">{t("sign-sns")}</div>
              <div className="decorator" />
            </div>
            <button
              className="google"
              onClick={(e) => {
                e.preventDefault();
                loginWithGoogle();
              }}
            >
              <img src="/img/icon-sign-google.svg" alt="google" />
              <div>{t("google-login")}</div>
            </button>
          </>
        )}
      </div>
    </StyledSignContainer>
  );
}
